import { useAuthContext } from "src/auth/AuthContext";
import { fundMoveService } from "@/service/FundMoveService";
import FundMoveForm from "./FundMoveForm";

const FundMoveAdd = () => {
    const { user } = useAuthContext();
    return (
        <FundMoveForm
            fundMoveId={-1}
            organizationId={user?.data?.organizationId}
            onSubmit={entry => fundMoveService.add(entry)}
            header="Neue Fondsänderung"
        />
    );
};

export default FundMoveAdd;
